<template>
    <div class="container-fluid no-min-height">
        <div class="row">
            <div class="col-12 col-lg-6 offset-lg-3">
                <h2 class="mb-2">{{ formData.title }}</h2>
                <div class="position-relative">
                    <transition name="fade">
                        <form
                            v-if="!success"
                            key="form"
                            @submit.prevent="validateAndSubmit"
                        >
                            <h3>
                                Hoe oud ben je op 1 augustus van dit schooljaar?
                            </h3>
                            <RadioInput
                                v-model="form.age"
                                v-validate="'required'"
                                :class="'mb-3'"
                                data-vv-as="Leeftijd"
                                :options="[
                                    {
                                        name: 'Jonger dan 18 jaar',
                                        checked: true
                                    },
                                    {
                                        name: '18 jaar of ouder, thuiswonend',
                                        checked: false
                                    },
                                    {
                                        name:
                                            '18 jaar of ouder, zelfstandig wonend',
                                        checked: false
                                    }
                                ]"
                                :disabled="processing"
                                :error="errors.first('age')"
                                :name="'age'"
                                placeholder="Leeftijd"
                            ></RadioInput>
                            <h3
                                v-if="
                                    form.age === '18 jaar of ouder, thuiswonend'
                                "
                                class="mb-2"
                            >
                                je kunt in dit geval geen beroep doen op
                                financiële ondersteuning uit het
                                Mbo-Studentenfonds.
                            </h3>
                            <div v-else class="row">
                                <div class="col-12">
                                    <h3>
                                        Gegevens student
                                    </h3>
                                </div>
                                <TextInput
                                    v-model="form.firstName"
                                    v-validate="'required'"
                                    data-vv-as="Voornaam"
                                    :disabled="processing"
                                    :error="errors.first('firstName')"
                                    :name="'firstName'"
                                    label="Voornaam*"
                                    placeholder="Voornaam*"
                                    :class="'col-12 col-lg-4'"
                                ></TextInput>

                                <TextInput
                                    v-model="form.lastName"
                                    v-validate="'required'"
                                    data-vv-as="Achternaam"
                                    :disabled="processing"
                                    :error="errors.first('lastName')"
                                    :name="'lastName'"
                                    label="Achternaam*"
                                    placeholder="Achternaam*"
                                    :class="'col-12 col-lg-4'"
                                ></TextInput>

                                <TextInput
                                    v-model="form.studentNumber"
                                    v-validate="'required'"
                                    data-vv-as="Studentnummer"
                                    :disabled="processing"
                                    :error="errors.first('studentNumber')"
                                    :name="'studentNumber'"
                                    label="Studentnummer*"
                                    placeholder="Studentnummer*"
                                    :class="'col-12 col-lg-4'"
                                ></TextInput>

                                <TextInput
                                    v-if="form.age === 'Jonger dan 18 jaar'"
                                    v-model="form.HCMailAddress"
                                    v-validate="'required|email'"
                                    data-vv-as="E-mailadres"
                                    :disabled="processing"
                                    :error="errors.first('HCMailAddress')"
                                    :name="'HCMailAddress'"
                                    label="E-mailadres *"
                                    placeholder="E-mailadres ouder*"
                                    :class="'col-12 col-lg-6'"
                                ></TextInput>
                                <TextInput
                                    v-if="
                                        form.age ===
                                            '18 jaar of ouder, zelfstandig wonend'
                                    "
                                    v-model="form.HCMailAddress"
                                    v-validate="'required|email'"
                                    data-vv-as="HC-mailadres"
                                    :disabled="processing"
                                    :error="errors.first('HCMailAddress')"
                                    :name="'HCMailAddress'"
                                    label="HC-mailadres*"
                                    placeholder="HC-mailadres*"
                                    :class="'col-12 col-lg-6'"
                                ></TextInput>

                                <TextInput
                                    v-if="form.age === 'Jonger dan 18 jaar'"
                                    v-model="form.phoneNumber"
                                    v-validate="'required'"
                                    data-vv-as="Telefoonnummer ouder"
                                    :disabled="processing"
                                    :error="errors.first('phoneNumber')"
                                    :name="'phoneNumber'"
                                    label="Telefoonnummer ouder*"
                                    placeholder="Telefoonnummer ouder*"
                                    :class="'mb-3 col-12 col-lg-6'"
                                ></TextInput>

                                <TextInput
                                    v-if="
                                        form.age ===
                                            '18 jaar of ouder, zelfstandig wonend'
                                    "
                                    v-model="form.phoneNumber"
                                    v-validate="'required'"
                                    data-vv-as="Telefoonnummer"
                                    :disabled="processing"
                                    :error="errors.first('phoneNumber')"
                                    :name="'phoneNumber'"
                                    label="Telefoonnummer*"
                                    placeholder="Telefoonnummer*"
                                    :class="'mb-3 col-12 col-lg-6'"
                                ></TextInput>
                                <div class="col-12">
                                    <h3>
                                        Gegevens opleiding
                                    </h3>
                                </div>
                                <TextInput
                                    v-model="form.educationName"
                                    v-validate="'required'"
                                    data-vv-as="Naam opleiding"
                                    :disabled="processing"
                                    :error="errors.first('educationName')"
                                    :name="'educationName'"
                                    label="Naam opleiding*"
                                    placeholder="Naam opleiding*"
                                    :class="'col-12 col-lg-6'"
                                ></TextInput>
                                <RadioInput
                                    v-model="form.educationDirection"
                                    v-validate="'required'"
                                    :class="'mb-3 col-12 col-lg-6'"
                                    data-vv-as="Leerweg"
                                    :options="[
                                        {
                                            name: 'BOL',
                                            checked: true
                                        },
                                        {
                                            name: 'BBL',
                                            checked: false
                                        }
                                    ]"
                                    :disabled="processing"
                                    :error="errors.first('educationDirection')"
                                    :name="'educationDirection'"
                                    label="Leerweg"
                                    placeholder="Leerweg"
                                ></RadioInput>
                                <div class="col-12">
                                    <h3>
                                        Kosten leermiddelen opleiding
                                    </h3>
                                </div>
                                <checkbox-input
                                    v-model="form.laptopValue"
                                    label="Voor welke leermiddelen vraag je
                                        financiële ondersteuning?"
                                    :class="'col-12 checkbox--orange'"
                                    data-vv-as="Leerweg"
                                    :options="[
                                        {
                                            name: 'Laptop',
                                            checked: false
                                        }
                                    ]"
                                    :disabled="processing"
                                    :error="errors.first('laptop')"
                                    :name="'Laptop'"
                                    placeholder="Laptop"
                                ></checkbox-input>
                                <div
                                    v-show="form.laptopValue.length > 0"
                                    class="mb-1"
                                >
                                    <checkbox-input
                                        v-model="form.laptopOptions"
                                        label="Extra opties voor bij de laptop:"
                                        :class="'col-12 checkbox--orange'"
                                        data-vv-as="Leerweg"
                                        :options="extraLaptopOptions"
                                        :disabled="processing"
                                        :name="'Laptopbenodigdheden'"
                                        placeholder="Laptopbenodigdheden"
                                    ></checkbox-input>
                                </div>
                                <RadioInput
                                    v-model="form.supplies"
                                    v-validate="'required'"
                                    :class="'mb-1 col-12 col-lg-6'"
                                    :options="[
                                        {
                                            name:
                                                'Voor alle leermiddelen die op de leermiddelenlijst staan',
                                            checked: true
                                        },
                                        {
                                            name:
                                                'Voor de volgende leermiddelen: (vul hier exact de leermiddelen in, incl. ISBN nummers!)',
                                            checked: false
                                        }
                                    ]"
                                    :disabled="processing"
                                    :error="errors.first('supplies')"
                                    :name="'supplies'"
                                    placeholder="Voor welke leermiddelen vraag je financiële ondersteuning?"
                                ></RadioInput>
                                <TextAreaInput
                                    v-if="
                                        form.supplies ===
                                            'Voor de volgende leermiddelen: (vul hier exact de leermiddelen in, incl. ISBN nummers!)'
                                    "
                                    v-model="form.suppliesList"
                                    v-validate="'required'"
                                    data-vv-as="leermiddelen"
                                    :disabled="processing"
                                    :error="errors.first('suppliesList')"
                                    :name="'suppliesList'"
                                    :rows="3"
                                    :class="'mb-3 col-12'"
                                    :placeholder="
                                        'Vul hier je leermiddelen in*'
                                    "
                                ></TextAreaInput>

                                <div class="col-12">
                                    <h3>
                                        Toelichting op aanvraag
                                    </h3>
                                </div>

                                <TextAreaInput
                                    v-model="form.extraInformation"
                                    v-validate="'required'"
                                    data-vv-as="Toelichting"
                                    :disabled="processing"
                                    :error="errors.first('extraInformation')"
                                    :name="'extraInformation'"
                                    :label="'Toelichting'"
                                    :rows="5"
                                    :placeholder="'Vul hier je toelichting in*'"
                                    :class="'mb-1 col-12 mb-3'"
                                ></TextAreaInput>

                                <div class="col-12">
                                    <h3>
                                        Hoogte (gezins)inkomen per maand
                                    </h3>
                                </div>

                                <TextInput
                                    v-model="form.income"
                                    v-validate="'required'"
                                    data-vv-as="Vul hier het gemiddelde inkomen per maand in"
                                    :disabled="processing"
                                    :error="errors.first('income')"
                                    :name="'income'"
                                    label="Vul hier het gemiddelde inkomen per maand in*"
                                    placeholder="Vul hier het gemiddelde inkomen per maand in*"
                                    :class="'mb-3 col-12'"
                                ></TextInput>

                                <div
                                    v-if="
                                        form.age ===
                                            '18 jaar of ouder, zelfstandig wonend'
                                    "
                                    class="col-12 mb-3"
                                >
                                    <h3>
                                        Meesturen bewijsstukken
                                    </h3>
                                    <p>
                                        Voeg in ieder geval de leermiddelenlijst
                                        toe!
                                    </p>
                                    <p>
                                        Het is noodzakelijk om één van de
                                        volgende documenten als bewijsstuk te
                                        uploaden:
                                    </p>

                                    <ul class="pl-1">
                                        <li>
                                            Kwijtschelding gemeentelijke
                                            belastingen of waterschapsbelasting
                                            2023 <b>of</b>
                                        </li>
                                        <li>
                                            Verklaring van je bewindvoerder over
                                            het (gezins)inkomen <b>of</b>
                                        </li>
                                        <li>
                                            Verklaring AZC over leefgeld
                                        </li>
                                    </ul>
                                    <p>
                                        Daarnaast is het noodzakelijk om de
                                        volgende documenten ook te uploaden:
                                    </p>
                                    <ul class="pl-1">
                                        <li>
                                            Bankafschriften van de afgelopen 3
                                            maanden
                                        </li>
                                    </ul>
                                    <p>Als je een BOL opleiding volgt:</p>
                                    <ul class="pl-1">
                                        <li>
                                            Overzicht uit DUO met het
                                            maandbedrag
                                        </li>
                                        <li>
                                            2 recente salarisspecificaties van
                                            je bijbaan (een afschrift van je
                                            bank is niet voldoende)
                                        </li>
                                    </ul>
                                    <p>Als je een BBL opleiding volgt:</p>
                                    <ul class="pl-1">
                                        <li>
                                            recente salarisspecificaties (een
                                            afschrift van je bank is niet
                                            voldoende)
                                        </li>
                                    </ul>
                                    <p>
                                        Zonder bewijsstukken kunnen we je
                                        aanvraag niet in behandeling nemen. Kun
                                        je de documenten niet overleggen of
                                        uploaden, neem dan contact op met één
                                        van onze budgetcoaches:
                                        <a
                                            href="mailto:betalingleermiddelen@horizoncollege.nl"
                                            >betalingleermiddelen@horizoncollege.nl</a
                                        >
                                    </p>
                                </div>
                                <div
                                    v-if="form.age === 'Jonger dan 18 jaar'"
                                    class="col-12 mb-3"
                                >
                                    <h3>
                                        Meesturen bewijsstukken
                                    </h3>
                                    <p>
                                        Voeg in ieder geval de leermiddelenlijst
                                        toe!
                                    </p>
                                    <p>
                                        Het is noodzakelijk om één van de
                                        volgende documenten als bewijsstuk te
                                        uploaden:
                                    </p>

                                    <ul class="pl-1">
                                        <li>
                                            Kwijtschelding gemeentelijke
                                            belasting of waterschapsbelasting
                                            2023
                                        </li>
                                        <li>
                                            Recent bewijs van uitkering over
                                            afgelopen 2 maanden (bijv.
                                            WW/bijstand/WIA)
                                        </li>
                                        <li>
                                            Recente salarisspecificaties over de
                                            afgelopen 2 maanden
                                        </li>
                                        <li>
                                            Bewijs van WSNP (Wet Schuldsanering
                                            Natuurlijke Personen)
                                        </li>
                                        <li>
                                            Verklaring van je bewindvoerder over
                                            het (gezins)inkomen
                                        </li>
                                        <li>
                                            Verklaring van je voogdij-instelling
                                            over het (gezins)inkomen
                                        </li>
                                        <li>Verklaring AZC over leefgeld</li>
                                        <li>
                                            Verklaring of bewijs van toekenning
                                            Voedselbank
                                        </li>
                                        <li>Verklaring Stichting Leergeld</li>
                                    </ul>
                                    <p>
                                        Zonder bewijsstukken kunnen we je
                                        aanvraag niet in behandeling nemen. Kun
                                        je de documenten niet overleggen of
                                        uploaden, neem dan contact op met één
                                        van onze budgetcoaches:
                                        <a
                                            href="mailto:betalingleermiddelen@horizoncollege.nl"
                                            >betalingleermiddelen@horizoncollege.nl</a
                                        >
                                    </p>
                                </div>

                                <div class="file-input mb-3">
                                    <label class="btn btn-primary mb-2"
                                        >Bestanden toevoegen
                                        <input
                                            id="files"
                                            ref="files"
                                            type="file"
                                            multiple
                                            @change="submitFiles()"
                                        />
                                    </label>
                                    <ul
                                        v-if="attachments.length"
                                        class="included-files list-unstyled p-1"
                                    >
                                        <li
                                            v-for="(file, index) in attachments"
                                            :key="index"
                                        >
                                            {{ file.name }}
                                        </li>
                                    </ul>
                                </div>
                                <span class="ml-2">
                                    <button
                                        class="btn btn-primary mb-1"
                                        :disabled="processing"
                                        type="submit"
                                    >
                                        Verstuur
                                    </button>
                                </span>
                            </div>
                        </form>
                        <div
                            v-else
                            key="successMessage"
                            class="rte"
                            v-html="formData.successMessage"
                        ></div>
                    </transition>
                    <div
                        v-if="!success && error"
                        key="errorMessage"
                        class="rte form-failed"
                        v-html="errorMessageFromApi"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import FormSubmissionMixin from '@/js/mixins/form-submission-mixin.js';
import TextInput from '@/components/form/text-input';
import RadioInput from '@/components/form/radio-input';
import TextAreaInput from '@/components/form/textarea-input';
import Axios from 'axios';
import CheckboxInput from '../form/checkbox-input.vue';

Vue.use(VueReCaptcha, { siteKey: '6LfB5cMUAAAAAOnv1Nn1d1neosmH_X5xVuUx0zu4' });

export default {
    components: {
        TextInput,
        RadioInput,
        TextAreaInput,
        CheckboxInput
    },

    mixins: [FormSubmissionMixin],

    props: {
        formData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            form: {
                age: 'Jonger dan 18 jaar',
                firstName: '',
                lastName: '',
                studentNumber: '',
                HCMailAddress: '',
                phoneNumber: '',
                supplies:
                    'Voor alle leermiddelen die op de leermiddelenlijst staan',
                suppliesList: '',
                educationName: '',
                educationDirection: 'BOL',
                laptopValue: [],
                laptopOptions: [],
                laptop: false,
                income: '',
                extraInformation: ''
            },
            extraLaptopOptions: [
                {
                    name: 'Laptopstandaard',
                    checked: false
                },
                {
                    name: 'Toetsenbord',
                    checked: false
                },
                {
                    name: 'Muis',
                    checked: false
                }
            ],
            attachments: [],
            postUrl: '/api/FinancialSupportApi/Submit'
        };
    },
    computed: {
        errorMessageFromApi() {
            return this.errorMessage;
        }
    },
    watch: {
        'form.laptopValue': {
            handler: function(value) {
                if (value.length < 1) {
                    this.form.laptopOptions = [];
                }
                for (
                    let index = 0;
                    index < this.extraLaptopOptions.length;
                    index++
                ) {
                    const element = this.extraLaptopOptions[index];
                    element.checked = false;
                }
            }
        }
    },
    methods: {
        submitFiles() {
            const uploadedFiles = this.$refs.files.files;
            for (let i = 0; i < uploadedFiles.length; i++) {
                this.attachments.push(uploadedFiles[i]);
            }
        },
        submitForm(url, data) {
            const myFormData = new FormData();
            this.form.laptop = this.form.laptopValue.length > 0;

            for (let i = 0; i < this.attachments.length; i++) {
                const file = this.attachments[i];
                myFormData.append('files[' + i + ']', file);
            }

            myFormData.append('content', JSON.stringify(data));

            Axios.post(
                url + '?nodeId=' + this.$root.settings.nodeId,
                myFormData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
                .then(response => {
                    if (!response.data.success) {
                        this.error = true;
                        this.errorMessage = response.data.message;
                        this.success = false;
                        this.processing = false;
                        return false;
                    }

                    this.error = false;
                    this.success = true;
                    this.processing = false;
                    return true;
                })
                .catch(() => {
                    this.error = true;
                    this.errorMessage =
                        'Er ging iets mis, probeer het later opnieuw.';
                    this.success = false;
                    this.processing = false;
                    return false;
                });
        }
    }
};
</script>

<style lang="scss">
.file-input input {
    display: none;
}

.included-files {
    background-color: $color-gray;
}
</style>
